import { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { Box, Heading } from '../../../components';
import UserForm from './UserForm';
import PhoneNumberForm from './PhoneNumberForm';
import * as messages from '../messages';
import { CurrentUser } from '../../../core-types';

const PersonalInfo = ({ currentUser }: { currentUser: CurrentUser }) => {
  return (
    <Fragment>
      <Heading textAlign="center" mb={6}>
        <FormattedMessage {...messages.sections['personal-info']} />
      </Heading>
      <Box mb="md">
        <PhoneNumberForm currentUser={currentUser} />
      </Box>
      <Box>
        <UserForm currentUser={currentUser} />
      </Box>
    </Fragment>
  );
};

export default PersonalInfo;
